import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {GameCompetitorViewModel} from "../../../domain/partial-game/models/game-competitor/game-competitor-view-model";
import {GamePossession} from "./game.possession";
import styles from "./game-score.module.scss";
import classNames from "classnames";

export class GameScoreProps extends BaseProps {
  competitor: GameCompetitorViewModel;
  score: String;
  competitorScoreContainerClassName: String;
}

export const GameScoreText = ({
                                competitor,
                                isHomeCompetitor,
                                score,
                                shouldRenderPossession,
                                className
                              }: GameScoreProps) => {

  const possessionProps = {
    competitor: competitor,
    isHomeCompetitor: isHomeCompetitor,
    shouldRenderPossession: shouldRenderPossession
  }

  return (
    <div
      className={classNames(className, styles.competitor_score_container, {[styles.away_competitor_score_container]: !isHomeCompetitor})}>
      <GamePossession {...possessionProps}/>
      {score}
    </div>
  )
}
